import React from 'react'

export const EndMessage = () => (
  <div className="info-message">You have seen all results</div>
)
